import ProviderClaimsSummary from '../../../reports/claimsnew/ProviderClaimsSummary';

const InsurancePoliciesChart = () => <ProviderClaimsSummary />;

export default InsurancePoliciesChart;
